import * as ActionTypes from './ActionTypes';

//--------------------------------------------------------------------------//
//----------------------------------- Basket Section -------------------------//
//--------------------------------------------------------------------------//
// //-------------------- In Case we Got Ower Data  ---------------------------//
export const PostToBaske = (BasketItem) => (dispatch) => {
  setTimeout(() => {
    console.log('BasketItem', BasketItem);
    dispatch(getBasketInfo(BasketItem));
  }, 2000);
};

export const DeleteBasketitem = (BasketItemIndex) => (dispatch) => {
  setTimeout(() => {
    console.log('BasketItemIndex', BasketItemIndex);
    dispatch(DeleteItemFromBasket(BasketItemIndex));
  }, 2000);
};

//-------------------Empty Basket --------------------------------------//
export const EmptyBasket = (Basket) => (dispatch) => {
  console.log('BasketItemIndex', Basket);
  dispatch(OrderAdd(Basket));
  dispatch(emptyBasket());
};

//---------------- In Case of the Connection Failed ------------------------//
export const getBasketInfo = (BasketItem) => ({
  type: ActionTypes.BASKET_ADD,
  payload: BasketItem,
});

//---------------- In Case of the Connection Failed ------------------------//
export const emptyBasket = () => ({
  type: ActionTypes.BASKET_EMPTY,
  payload: [],
});
export const DeleteItemFromBasket = (BasketItemIndex) => ({
  type: ActionTypes.BASKET_DELETE,
  payload: BasketItemIndex,
});
//--------------------------------------------------------------------------//
//----------------------------------- User Section -------------------------//
//--------------------------------------------------------------------------//

export const SetActiveUser = (user) => (dispatch) => {
  setTimeout(() => {
    console.log('BasketItemIndex', user);
    console.log(user, 'useeeeeeeeeeeeeeet');
    dispatch(SetUser(user));
  }, 500);
};

const SetUser = (user) => ({
  type: ActionTypes.SET_USER,
  payload: user,
});

export const diactiveUser = () => (dispatch) => {
  setTimeout(() => {
    console.log('BasketItemIndex');
    console.log('useeeeeeeeeeeeeeet');
    dispatch(removeUser());
  }, 500);
};

const removeUser = () => ({
  type: ActionTypes.SET_USER,
  payload: null,
});

//--------------------------- Orders Section ----------------------------------//
//---------------- In Case of the Connection Failed ------------------------//
export const OrderAdd = (Basket) => ({
  type: ActionTypes.ORDERS_ADD,
  payload: Basket,
});
